/* eslint-disable */
export default {
  unknown: 'Sconosciuto',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
